var metaInfo={
    title:"仓储物流_Movibot服务行业",
    keywords:"仓储物流工业机器人_移动机器人_仓储物流工业机器人价格",
    description:"仓储物流工业机器人,移动机器人,搬运机器人,顶升机器人,料箱机器人,伸缩臂机器人,AMB系列机器人",
}

export default {
    metaInfo
  };


// WEBPACK FOOTER //
// ./src/data/metaInfo/4.js